import React, { useEffect, useState } from 'react'
import { useUserContext } from '../../contexts/UserContext';
import ButtonShimmer from '../UI/Shimmer/ButtonShimmer';
import useComponentVisible from '../UI/ComponentVisible';
import { toast } from 'react-toastify';
import { useAuth0 } from "@auth0/auth0-react";
import { trackAnalyticsEvent } from '../../utils/APIs';
import { Building2, ChevronDown, Check } from 'lucide-react';

const ManageAccountSelectBox = () => {
    const { userData, setSelectedOrganization,loading, getAllAppData } = useUserContext()
    const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);
    const [filteredAccountData, setFilteredAccountData] = useState();
    const { user } = useAuth0();

    const filterAccountHandler = () => {
        let accountData = userData?.organizations?.filter((org) => {
            return org.name !== userData?.selectedOrganization?.name;
        }) || [];

        accountData.sort(function (a, b) {
            if (a.display_name < b.display_name) {
              return -1;
            }
            if (a.display_name > b.display_name) {
              return 1;
            }
            return 0;
        });

        return accountData;
    }

    useEffect(() => {
        setFilteredAccountData(filterAccountHandler());
        getAllAppData()
    }, [userData?.selectedOrganization]);

    return (
        <div ref={ref} className="relative z-[1001]">
            {loading ? <ButtonShimmer/> : (
                <button
                    className="bg-white hover:bg-slate-50 text-slate-800 border border-border-subtle hover:border-primary/60 focus:ring-2 focus:ring-primary/20 focus:border-primary focus:outline-none rounded-xl text-xs md:text-sm font-medium px-3.5 py-1.5 flex items-center justify-between gap-2 min-w-[150px] max-w-[240px] w-full cursor-pointer transition-all shadow-xs"
                    title={userData?.selectedOrganization?.display_name}
                    type="button"
                    onMouseDown={(e) => { 
                        e.stopPropagation();
                        setIsComponentVisible(!isComponentVisible);
                    }}
                >
                    <div className="flex items-center gap-2 min-w-0 flex-1">
                        <Building2 size={15} className="text-primary shrink-0" />
                        <span className="truncate font-semibold text-slate-800">
                            {userData?.selectedOrganization?.display_name ?? 'Account'}
                        </span>
                    </div>
                    <ChevronDown size={14} className={`text-slate-400 shrink-0 transition-transform ${isComponentVisible ? 'rotate-180' : ''}`} />
                </button>
            )}
            {isComponentVisible && (
                <div className="bg-white border border-border rounded-xl shadow-xl absolute top-full mt-1.5 w-[240px] z-[1002] p-1.5 divide-y divide-slate-100 animate-in fade-in zoom-in-95 duration-100">
                    <div className="px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider text-slate-400">
                        Organizations
                    </div>
                    <ul className="py-1 text-xs md:text-sm text-slate-700 space-y-0.5">
                        <li>
                            <a
                                href="#"
                                className="flex items-center justify-between px-3 py-2 bg-primary-soft text-primary font-bold rounded-lg break-words transition-colors"
                                title={userData?.selectedOrganization?.display_name}
                                onMouseDown={(e) => { 
                                    e.preventDefault();
                                    e.stopPropagation();
                                    setSelectedOrganization(userData?.selectedOrganization);
                                    setIsComponentVisible(false);
                                }}
                            >
                                <span className="truncate">{userData?.selectedOrganization?.display_name}</span>
                                <Check size={14} className="text-primary shrink-0 ml-2" />
                            </a>
                        </li>
                        {filteredAccountData?.map((org) => (
                            <li key={org.org_token}>
                                <a
                                    href="#"
                                    className={`flex items-center justify-between px-3 py-2 rounded-lg break-words transition-colors ${
                                        org.isBlocked 
                                            ? 'text-slate-400 cursor-not-allowed' 
                                            : 'hover:bg-slate-50 text-slate-700 font-medium'
                                    }`}
                                    title={org.display_name}
                                    onMouseDown={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        if (org?.isBlocked) {
                                            toast.warn("You are blocked from this organization. Please contact your owner.");
                                            return;
                                        }
                                        setSelectedOrganization(org);
                                        setIsComponentVisible(false);
                                        trackAnalyticsEvent(userData?.token, org.org_token, {
                                            event_name: 'USER_LOGIN',
                                            status: 'success',
                                            metadata: {
                                                email: user?.email || userData?.email,
                                                source: 'stride'
                                            }
                                        });
                                    }}
                                >
                                    <span className="truncate">{org.display_name}</span>
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    )
}

export default ManageAccountSelectBox;